export const scrollToSection = (target) => {
  const el = document.querySelector(target);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: 'smooth' });
  }
};

export const prefillServiceAndScroll = (service) => {
  window.dispatchEvent(new CustomEvent('prefill-service', { detail: service }));
  scrollToSection('#contato-form');
};
